module.exports = __webpack_public_path__ + "img/eagletrade-small.6ca3c538.png";